import React, { useContext } from 'react';
import { getStreetName } from '../../../utils/getStreetName';
import { Checkbox } from 'antd';
import styles from './HouseList.module.scss';
import HouseRegisterCheck from '../HouseRegisterCheck/HouseRegisterCheck';
import {
  HandleSelectAllChangeContext,
  SelectedItemsContext,
} from '../../../pages/ChangingAllPage/Provider';

const HouseList = ({ houseFilter, streetId }) => {
  const handleSelectAllChange = useContext(HandleSelectAllChangeContext);
  const selectedItems = useContext(SelectedItemsContext);

  const changeCheckBox = (e) => {
    handleSelectAllChange(streetId, e.target.checked);
  };

  return (
    <div className={styles.container}>
      <div className={styles.block}>
        <div className={styles.title}>
          {getStreetName(houseFilter[0].streetName)}
        </div>
        <Checkbox
          className={styles.customCheckboxReg}
          checked={houseFilter?.every((item) =>
            selectedItems?.find((selected) => selected.houseId === item.houseId)
          )}
          onChange={changeCheckBox}
        />
      </div>
      <div
        style={{
          maxHeight: '300px',
          overflowY: 'auto',
          direction: 'rtl',
        }}
      >
        <div
          style={{
            direction: 'ltr',
            display: 'flex',
            flexDirection: 'column',
            gap: '20px',
            marginRight: '5px',
            marginLeft: '5px',
          }}
        >
          {houseFilter.map((house) => (
            <HouseRegisterCheck
              key={house.houseId}
              house={house}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default HouseList;
